import * as React from 'react';

const MagnifyingGlass = (props: any) => {
  const { className, fillColor = '#171717', ...otherProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      className={className}
      {...otherProps}
    >
      <mask
        id="a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill="#7E7E7E" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill={fillColor}
          d="M9.52 15.616c-1.709 0-3.155-.593-4.34-1.777-1.184-1.185-1.776-2.631-1.776-4.339 0-1.708.592-3.154 1.777-4.338 1.184-1.185 2.63-1.777 4.338-1.777 1.708 0 3.154.592 4.339 1.777 1.184 1.184 1.776 2.63 1.776 4.338 0 .714-.12 1.396-.36 2.046-.239.65-.559 1.216-.959 1.696l5.754 5.754c.139.139.21.313.213.522a.707.707 0 0 1-.213.532.718.718 0 0 1-.527.217.717.717 0 0 1-.527-.217l-5.754-5.754c-.5.413-1.074.736-1.724.97-.65.233-1.323.35-2.018.35Zm0-1.5c1.288 0 2.379-.448 3.273-1.342.894-.894 1.342-1.985 1.342-3.274 0-1.288-.448-2.38-1.342-3.274-.894-.894-1.985-1.341-3.274-1.341-1.288 0-2.38.447-3.274 1.341-.894.894-1.341 1.986-1.341 3.274 0 1.289.447 2.38 1.341 3.274.894.894 1.986 1.342 3.274 1.342Z"
        />
      </g>
    </svg>
  );
};

export default MagnifyingGlass;
